module.exports = __webpack_public_path__ + "static/media/burn_header.03ada763.png";